import DeleteIcon from "@mui/icons-material/Delete";
import { Chip, IconButton, Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import theme from "../styles/theme";
import { Category, ExerciseId, ExerciseIdWithName } from "../types";

interface EditListItem {
    exercise: ExerciseIdWithName & { isAi: boolean };
    handleDelete: (id: ExerciseId) => void;
}

export const EditListItem: React.FunctionComponent<EditListItem> = ({ exercise, handleDelete }) => {
    const { i18n, t } = useTranslation();
    return (
        <li>
            <Stack direction="row" alignItems="center">
                {i18n.language === "de" ? exercise.nameDe : exercise.nameEn}
                {exercise.isAi && (
                    <Chip
                        label={t(Category.Ai)}
                        sx={{ backgroundColor: theme.colors[Category.Ai], color: theme.palette.primary.contrastText, marginX: 1 }}
                    />
                )}
                <IconButton aria-label="Delete" onClick={() => handleDelete(exercise.id)}>
                    <DeleteIcon />
                </IconButton>
            </Stack>
        </li>
    );
};
